const intersection = (arrayA, arrayB) => {
    if (!Array.isArray(arrayA) || !Array.isArray(arrayB)) {
        return [];
    }

    return arrayA.filter(Set.prototype.has, new Set(arrayB));
};

export default intersection;